import React from 'react';
export function NotFound404() {

    return (
        <div className='text-center text-4xl p-6'>
            <div>404</div>
            <div className='text-lg'>Страница не найдена</div>
        </div>
    );
}